var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 480,
    width: 640,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "red",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff0",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    y2: 107.76,
    xlinkHref: "#a",
    gradientUnits: "userSpaceOnUse",
    y1: 111.28,
    gradientTransform: "matrix(.64274 0 0 1.4534 -94.683 29.21)",
    x2: 92.551,
    x1: 103.08
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    y2: 107.76,
    xlinkHref: "#a",
    gradientUnits: "userSpaceOnUse",
    y1: 111.28,
    gradientTransform: "matrix(.64274 0 0 1.4534 -94.666 30.155)",
    x2: 92.551,
    x1: 103.08
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    y2: 107.76,
    xlinkHref: "#a",
    gradientUnits: "userSpaceOnUse",
    y1: 111.28,
    gradientTransform: "matrix(.64274 0 0 1.4534 -97.986 31.014)",
    x2: 92.551,
    x1: 103.08
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    y2: 107.76,
    xlinkHref: "#a",
    gradientUnits: "userSpaceOnUse",
    y1: 111.28,
    gradientTransform: "matrix(.64274 0 0 1.4534 -94.743 31.932)",
    x2: 92.551,
    x1: 103.08
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    y2: 107.76,
    xlinkHref: "#a",
    gradientUnits: "userSpaceOnUse",
    y1: 111.28,
    gradientTransform: "matrix(.64274 0 0 1.4534 -94.75 32.835)",
    x2: 92.551,
    x1: 103.08
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    y2: 107.76,
    xlinkHref: "#a",
    gradientUnits: "userSpaceOnUse",
    y1: 111.28,
    gradientTransform: "matrix(.64274 0 0 1.4534 -94.767 33.751)",
    x2: 92.551,
    x1: 103.08
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    y2: 107.76,
    xlinkHref: "#a",
    gradientUnits: "userSpaceOnUse",
    y1: 111.28,
    gradientTransform: "matrix(.64274 0 0 1.4534 -98.011 33.736)",
    x2: 92.551,
    x1: 103.08
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    y2: 107.76,
    xlinkHref: "#a",
    gradientUnits: "userSpaceOnUse",
    y1: 111.28,
    gradientTransform: "matrix(.64274 0 0 1.4534 -97.981 32.837)",
    x2: 92.551,
    x1: 103.08
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    y2: 107.76,
    xlinkHref: "#a",
    gradientUnits: "userSpaceOnUse",
    y1: 111.28,
    gradientTransform: "matrix(.64274 0 0 1.4534 -97.942 31.918)",
    x2: 92.551,
    x1: 103.08
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    y2: 107.76,
    xlinkHref: "#a",
    gradientUnits: "userSpaceOnUse",
    y1: 111.28,
    gradientTransform: "matrix(.8281 0 0 1.8726 602.82 148.17)",
    x2: 92.551,
    x1: 103.08
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    y2: 107.76,
    xlinkHref: "#a",
    gradientUnits: "userSpaceOnUse",
    y1: 111.28,
    gradientTransform: "matrix(.64274 0 0 1.4534 -97.976 30.11)",
    x2: 92.551,
    x1: 103.08
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    y2: 107.76,
    xlinkHref: "#a",
    gradientUnits: "userSpaceOnUse",
    y1: 111.28,
    gradientTransform: "matrix(.64274 0 0 1.4534 -95.336 30.955)",
    x2: 92.551,
    x1: 103.08
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.67,
    d: "M0 0h640v480H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#006",
    d: "M0 0h960v480H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#006",
    d: "M0 0h350.002v175H0z"
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0v19.566L310.871 175h39.13v-19.565L39.132.001H0zm350.002 0v19.565L39.13 175.001H0v-19.565L310.871 0h39.13z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.834 0v175h58.334V0h-58.334zM0 58.334v58.333h350.002V58.334H0z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 70v35h350.002V70H0zM157.5 0v175h35V0h-35zM0 175l116.667-58.333h26.087L26.087 175.001H0zM0 0l116.667 58.334H90.58L0 13.044V0zm207.248 58.334L323.915 0h26.087L233.334 58.334h-26.086zM350.002 175l-116.668-58.334h26.087l90.58 45.29v13.044z",
    fill: "#c00"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M378.474 154.457l219.342-.814-.407 195.333s7.732 29.706-91.967 74.876c35.81-3.663 74.876-41.914 74.876-41.914s15.87-20.347 23.603-8.953c7.731 11.394 15.056 17.091 20.753 21.568 5.697 4.476 10.174 16.685 1.628 25.637-8.546 8.952-21.974 10.173-25.637-.814-5.697 2.849-40.693 45.17-112.31 47.205-72.84-1.221-112.72-47.612-112.72-47.612s-9.766 15.464-23.602 3.256c-13.428-15.87-3.255-26.044-3.255-26.044s11.394-6.511 14.65-10.988c5.29-6.104 6.917-14.243 15.87-14.243 10.58.814 14.65 9.36 14.65 9.36s36.624 38.659 76.096 43.542c-89.12-42.728-92.375-69.18-91.968-75.69l.407-193.7z",
    fillRule: "evenodd",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.76 159.743l209.16-1.22v188.003c.407 24.416-40.694 49.24-104.99 80.98-66.323-34.183-104.57-54.939-104.98-81.381l.813-186.372z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.7173345,
    fill: "#006129"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.912 366.902l12.346-18.133 12.407 18.172",
    stroke: "#f7c600",
    strokeWidth: 1.71797946,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.739 360.115a2.452 2.452 0 1 1-4.904.002 2.452 2.452 0 0 1 4.904-.002z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.8050560000000001,
    fill: "#f7c600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.233 380.3l19.141.054s.3-2.484-2-3.994c10.026-1.378 7.422-10.222 15.818-10.723 1.63.25-4.386 3.76-4.386 3.76s-5.062 3.572-2.757 5.388c1.83 1.442 2.632-.877 2.883-2.631.25-1.755 8.145-2.883 7.018-7.895-1.88-4.136-12.908 2.757-12.908 2.757l-7.868-.044c-.49-.883-2.66-4.424-4.898-4.44-2.657.096-4.528 4.484-4.528 4.484h-17.796s-.61 4.566 8.413 5.443c2.032 2.653 3.607 3.394 5.373 4.081-1.178.981-1.51 2.168-1.504 3.76z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.80542686,
    fill: "#f7c600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.611 376.411l15.943-.054M405.31 367.008s1.275 7.457 7.161 9.223",
    stroke: "#000",
    strokeWidth: 0.80542686,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.32 170.54c.445-2.151 1.261-2.522 2.151-5.267.149-2.67-2.151-2.374-1.483-4.08 1.187-1.855.593-3.635-1.632-5.045.445 2.448-2.894 4.748-2.894 6.751s1.707 1.558 1.484 4.6c.148 1.78-.445 1.335-.593 3.041h2.967z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.609,
    fill: "url(#c)",
    transform: "matrix(1.3225 0 0 1.3225 316.617 141.369)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.542 349.227a2.256 2.256 0 1 1-4.512.001 2.256 2.256 0 0 1 4.512-.001z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.80542686,
    fill: "#f7c600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.214 329.58l12.346-18.134 12.407 18.172",
    stroke: "#f7c600",
    strokeWidth: 1.71797946,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.04 322.793a2.452 2.452 0 1 1-4.903.001 2.452 2.452 0 0 1 4.904-.001z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.8050560000000001,
    fill: "#f7c600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.535 342.977l19.141.055s.3-2.485-2-3.994c10.026-1.379 7.422-10.222 15.818-10.723 1.63.25-4.386 3.76-4.386 3.76s-5.062 3.572-2.757 5.388c1.83 1.442 2.632-.877 2.883-2.632.25-1.754 8.145-2.882 7.018-7.895-1.88-4.135-12.908 2.757-12.908 2.757l-7.868-.044c-.49-.883-2.66-4.424-4.898-4.44-2.657.097-4.528 4.484-4.528 4.484h-17.796s-.61 4.566 8.413 5.443c2.032 2.653 3.607 3.395 5.372 4.081-1.177.982-1.508 2.169-1.503 3.76z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.80542686,
    fill: "#f7c600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.913 339.089l15.943-.055M404.611 329.686s1.276 7.456 7.162 9.222",
    stroke: "#000",
    strokeWidth: 0.80542686,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.32 170.54c.445-2.151 1.261-2.522 2.151-5.267.149-2.67-2.151-2.374-1.483-4.08 1.187-1.855.593-3.635-1.632-5.045.445 2.448-2.894 4.748-2.894 6.751s1.707 1.558 1.484 4.6c.148 1.78-.445 1.335-.593 3.041h2.967z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.609,
    fill: "url(#d)",
    transform: "matrix(1.3225 0 0 1.3225 315.919 104.047)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.844 311.904a2.256 2.256 0 1 1-4.512.001 2.256 2.256 0 0 1 4.512-.001z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.80542686,
    fill: "#f7c600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.38 295.652l12.347-18.134 12.406 18.172",
    stroke: "#f7c600",
    strokeWidth: 1.71797946,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.207 288.865a2.452 2.452 0 1 1-4.904.002 2.452 2.452 0 0 1 4.904-.002z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.8050560000000001,
    fill: "#f7c600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.701 309.05l19.141.054s.3-2.484-1.999-3.994c10.026-1.379 7.421-10.222 15.818-10.723 1.629.25-4.387 3.76-4.387 3.76s-5.062 3.572-2.757 5.388c1.83 1.442 2.632-.877 2.883-2.632.25-1.754 8.146-2.882 7.018-7.895-1.88-4.135-12.908 2.757-12.908 2.757l-7.868-.043c-.49-.884-2.66-4.425-4.898-4.441-2.657.097-4.528 4.484-4.528 4.484H529.42s-.61 4.566 8.413 5.443c2.032 2.654 3.607 3.395 5.373 4.082-1.178.98-1.51 2.168-1.504 3.76z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.80542686,
    fill: "#f7c600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.08 305.16l15.942-.053M535.777 295.758s1.276 7.456 7.163 9.222",
    stroke: "#000",
    strokeWidth: 0.80542686,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.32 170.54c.445-2.151 1.261-2.522 2.151-5.267.149-2.67-2.151-2.374-1.483-4.08 1.187-1.855.593-3.635-1.632-5.045.445 2.448-2.894 4.748-2.894 6.751s1.707 1.558 1.484 4.6c.148 1.78-.445 1.335-.593 3.041h2.967z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.609,
    fill: "url(#e)",
    transform: "matrix(1.3225 0 0 1.3225 447.085 70.119)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.01 277.976a2.256 2.256 0 1 1-4.512.002 2.256 2.256 0 0 1 4.512-.002z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.80542686,
    fill: "#f7c600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.273 259.372l12.346-18.134 12.407 18.172",
    stroke: "#f7c600",
    strokeWidth: 1.71797946,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.1 252.585a2.452 2.452 0 1 1-4.904.001 2.452 2.452 0 0 1 4.904-.001z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.8050560000000001,
    fill: "#f7c600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.594 272.769l19.141.054s.3-2.484-2-3.994c10.026-1.378 7.422-10.221 15.818-10.723 1.63.251-4.386 3.76-4.386 3.76s-5.062 3.572-2.757 5.389c1.83 1.442 2.632-.877 2.883-2.632.25-1.754 8.145-2.882 7.018-7.895-1.88-4.136-12.908 2.757-12.908 2.757l-7.868-.044c-.49-.883-2.66-4.424-4.898-4.44-2.657.097-4.528 4.484-4.528 4.484h-17.796s-.61 4.566 8.413 5.443c2.032 2.653 3.606 3.394 5.372 4.081-1.177.981-1.508 2.168-1.503 3.76z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.80542686,
    fill: "#f7c600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.972 268.88l15.943-.054M407.67 259.477s1.276 7.457 7.162 9.223",
    stroke: "#000",
    strokeWidth: 0.80542686,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.32 170.54c.445-2.151 1.261-2.522 2.151-5.267.149-2.67-2.151-2.374-1.483-4.08 1.187-1.855.593-3.635-1.632-5.045.445 2.448-2.894 4.748-2.894 6.751s1.707 1.558 1.484 4.6c.148 1.78-.445 1.335-.593 3.041h2.967z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.609,
    fill: "url(#f)",
    transform: "matrix(1.3225 0 0 1.3225 318.978 33.838)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.903 241.696a2.256 2.256 0 1 1-4.512.001 2.256 2.256 0 0 1 4.512-.001z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.80542686,
    fill: "#f7c600"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M411.55 223.713l12.347-18.134 12.406 18.172",
    stroke: "#f7c600",
    strokeWidth: 1.71797946,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.377 216.926a2.452 2.452 0 1 1-4.904.001 2.452 2.452 0 0 1 4.904-.001z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.8050560000000001,
    fill: "#f7c600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.871 237.11l19.141.055s.3-2.485-1.999-3.994c10.026-1.38 7.421-10.222 15.818-10.723 1.629.25-4.387 3.76-4.387 3.76s-5.062 3.572-2.757 5.388c1.83 1.442 2.632-.877 2.883-2.632.25-1.754 8.146-2.882 7.018-7.895-1.88-4.135-12.908 2.757-12.908 2.757l-7.868-.044c-.49-.883-2.66-4.424-4.898-4.44-2.657.097-4.528 4.484-4.528 4.484H401.59s-.61 4.566 8.413 5.443c2.032 2.653 3.607 3.395 5.373 4.081-1.178.982-1.51 2.169-1.504 3.76z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.80542686,
    fill: "#f7c600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.25 233.222l15.942-.055M407.947 223.818s1.276 7.457 7.163 9.223",
    stroke: "#000",
    strokeWidth: 0.80542686,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.32 170.54c.445-2.151 1.261-2.522 2.151-5.267.149-2.67-2.151-2.374-1.483-4.08 1.187-1.855.593-3.635-1.632-5.045.445 2.448-2.894 4.748-2.894 6.751s1.707 1.558 1.484 4.6c.148 1.78-.445 1.335-.593 3.041h2.967z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.609,
    fill: "url(#g)",
    transform: "matrix(1.3225 0 0 1.3225 319.255 -1.82)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.18 206.037a2.256 2.256 0 1 1-4.512.001 2.256 2.256 0 0 1 4.512-.001z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.80542686,
    fill: "#f7c600"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M412.228 187.533l12.346-18.134 12.407 18.172",
    stroke: "#f7c600",
    strokeWidth: 1.71797946,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.054 180.746a2.452 2.452 0 1 1-4.903.001 2.452 2.452 0 0 1 4.903-.001z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.8050560000000001,
    fill: "#f7c600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.549 200.93l19.14.054s.3-2.484-1.999-3.993c10.026-1.38 7.422-10.222 15.818-10.724 1.63.251-4.386 3.76-4.386 3.76s-5.062 3.573-2.757 5.389c1.83 1.442 2.632-.877 2.882-2.632.25-1.754 8.146-2.882 7.018-7.895-1.88-4.135-12.908 2.757-12.908 2.757l-7.868-.044c-.49-.883-2.659-4.424-4.898-4.44-2.657.097-4.528 4.484-4.528 4.484h-17.795s-.61 4.566 8.413 5.443c2.031 2.653 3.606 3.395 5.372 4.081-1.177.982-1.509 2.169-1.504 3.76z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.80542686,
    fill: "#f7c600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.927 197.042l15.943-.055M408.625 187.638s1.275 7.457 7.162 9.223",
    stroke: "#000",
    strokeWidth: 0.80542686,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.32 170.54c.445-2.151 1.261-2.522 2.151-5.267.149-2.67-2.151-2.374-1.483-4.08 1.187-1.855.593-3.635-1.632-5.045.445 2.448-2.894 4.748-2.894 6.751s1.707 1.558 1.484 4.6c.148 1.78-.445 1.335-.593 3.041h2.967z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.609,
    fill: "url(#h)",
    transform: "matrix(1.3225 0 0 1.3225 319.933 -38)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.857 169.857a2.256 2.256 0 1 1-4.511.001 2.256 2.256 0 0 1 4.511-.001z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.80542686,
    fill: "#f7c600"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M540.355 188.122l12.347-18.134 12.406 18.172",
    stroke: "#f7c600",
    strokeWidth: 1.71797946,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.182 181.335a2.452 2.452 0 1 1-4.904.002 2.452 2.452 0 0 1 4.904-.002z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.8050560000000001,
    fill: "#f7c600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.676 201.52l19.141.054s.3-2.484-1.999-3.994c10.026-1.379 7.421-10.222 15.818-10.723 1.629.25-4.386 3.76-4.386 3.76s-5.063 3.572-2.757 5.388c1.83 1.442 2.631-.877 2.882-2.632.25-1.754 8.146-2.882 7.018-7.895-1.88-4.135-12.908 2.757-12.908 2.757l-7.868-.043c-.49-.884-2.659-4.425-4.898-4.441-2.657.097-4.528 4.484-4.528 4.484h-17.795s-.61 4.566 8.413 5.443c2.031 2.654 3.606 3.395 5.372 4.082-1.177.98-1.509 2.168-1.504 3.76z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.80542686,
    fill: "#f7c600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.054 197.63l15.944-.053M536.753 188.228s1.275 7.456 7.162 9.222",
    stroke: "#000",
    strokeWidth: 0.80542686,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.32 170.54c.445-2.151 1.261-2.522 2.151-5.267.149-2.67-2.151-2.374-1.483-4.08 1.187-1.855.593-3.635-1.632-5.045.445 2.448-2.894 4.748-2.894 6.751s1.707 1.558 1.484 4.6c.148 1.78-.445 1.335-.593 3.041h2.967z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.609,
    fill: "url(#i)",
    transform: "matrix(1.3225 0 0 1.3225 448.06 -37.411)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.985 170.446a2.256 2.256 0 1 1-4.511.002 2.256 2.256 0 0 1 4.511-.002z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.80542686,
    fill: "#f7c600"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M539.185 223.638l12.347-18.134 12.406 18.172",
    stroke: "#f7c600",
    strokeWidth: 1.71797946,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.012 216.85a2.452 2.452 0 1 1-4.904.002 2.452 2.452 0 0 1 4.904-.001z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.8050560000000001,
    fill: "#f7c600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.506 237.035l19.141.055s.3-2.485-1.999-3.994c10.026-1.379 7.421-10.222 15.818-10.723 1.629.25-4.387 3.76-4.387 3.76s-5.062 3.572-2.757 5.388c1.83 1.442 2.632-.877 2.883-2.632.25-1.754 8.146-2.882 7.018-7.895-1.88-4.135-12.908 2.757-12.908 2.757l-7.868-.044c-.49-.883-2.66-4.424-4.898-4.44-2.657.097-4.528 4.484-4.528 4.484h-17.796s-.61 4.566 8.413 5.443c2.032 2.653 3.607 3.395 5.373 4.081-1.178.982-1.51 2.169-1.504 3.76z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.80542686,
    fill: "#f7c600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.884 233.147l15.943-.055M535.582 223.744s1.276 7.456 7.163 9.222",
    stroke: "#000",
    strokeWidth: 0.80542686,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.32 170.54c.445-2.151 1.261-2.522 2.151-5.267.149-2.67-2.151-2.374-1.483-4.08 1.187-1.855.593-3.635-1.632-5.045.445 2.448-2.894 4.748-2.894 6.751s1.707 1.558 1.484 4.6c.148 1.78-.445 1.335-.593 3.041h2.967z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.609,
    fill: "url(#j)",
    transform: "matrix(1.3225 0 0 1.3225 446.89 -1.895)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.815 205.962a2.256 2.256 0 1 1-4.512.001 2.256 2.256 0 0 1 4.512-.001z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.80542686,
    fill: "#f7c600"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M537.615 259.94l12.346-18.134 12.407 18.172",
    stroke: "#f7c600",
    strokeWidth: 1.71797946,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.441 253.152a2.452 2.452 0 1 1-4.903.002 2.452 2.452 0 0 1 4.903-.002z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.8050560000000001,
    fill: "#f7c600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.936 273.337l19.14.054s.3-2.484-1.999-3.994c10.026-1.379 7.421-10.222 15.818-10.723 1.63.25-4.386 3.76-4.386 3.76s-5.062 3.572-2.757 5.388c1.83 1.442 2.632-.877 2.882-2.631.25-1.755 8.146-2.883 7.018-7.895-1.88-4.136-12.908 2.757-12.908 2.757l-7.868-.044c-.49-.883-2.659-4.424-4.898-4.44-2.657.096-4.528 4.484-4.528 4.484h-17.795s-.61 4.565 8.413 5.443c2.031 2.653 3.606 3.394 5.372 4.08-1.177.982-1.509 2.17-1.504 3.76z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.80542686,
    fill: "#f7c600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.314 269.448l15.943-.054M534.012 260.045s1.275 7.457 7.162 9.223",
    stroke: "#000",
    strokeWidth: 0.80542686,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.32 170.54c.445-2.151 1.261-2.522 2.151-5.267.149-2.67-2.151-2.374-1.483-4.08 1.187-1.855.593-3.635-1.632-5.045.445 2.448-2.894 4.748-2.894 6.751s1.707 1.558 1.484 4.6c.148 1.78-.445 1.335-.593 3.041h2.967z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.609,
    fill: "url(#k)",
    transform: "matrix(1.3225 0 0 1.3225 445.32 34.406)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.244 242.263a2.256 2.256 0 1 1-4.511.002 2.256 2.256 0 0 1 4.511-.002z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.80542686,
    fill: "#f7c600"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M539.183 367.27l12.346-18.132 12.407 18.17",
    stroke: "#f7c600",
    strokeWidth: 1.2882574999999998,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.005 360.496a2.452 2.452 0 1 1-4.903.002 2.452 2.452 0 0 1 4.903-.002z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.804776,
    fill: "#f7c600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.503 380.667l19.14.054s.3-2.484-1.999-3.994c10.026-1.378 7.422-10.222 15.818-10.723 1.629.251-4.386 3.76-4.386 3.76s-5.063 3.572-2.757 5.389c1.83 1.442 2.631-.877 2.882-2.632.25-1.754 8.146-2.882 7.018-7.895-1.88-4.136-12.908 2.757-12.908 2.757l-7.868-.044c-.49-.883-2.66-4.424-4.898-4.44-2.657.097-4.528 4.484-4.528 4.484H529.22s-.61 4.566 8.413 5.443c2.031 2.653 3.606 3.394 5.372 4.081-1.177.981-1.509 2.168-1.504 3.76z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.804776,
    fill: "#f7c600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.878 376.776l15.943-.054M535.58 367.384s1.275 7.456 7.162 9.222",
    stroke: "#000",
    strokeWidth: 0.804776,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.5 330.27c.573-2.772 1.625-3.25 2.772-6.786.191-3.44-2.772-3.059-1.912-5.257 1.53-2.39.765-4.683-2.103-6.5.574 3.155-3.727 6.118-3.727 8.698 0 2.581 2.198 2.008 1.911 5.926.192 2.294-.573 1.72-.764 3.92h3.823z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.784,
    fill: "url(#l)",
    transform: "translate(-301.49 28.259) scale(1.0265)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.81 349.605a2.256 2.256 0 1 1-4.511.001 2.256 2.256 0 0 1 4.511-.001z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.804776,
    fill: "#f7c600"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M538.99 331.364l12.346-18.134 12.407 18.172",
    stroke: "#f7c600",
    strokeWidth: 1.71797946,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.817 324.577a2.452 2.452 0 1 1-4.904.002 2.452 2.452 0 0 1 4.904-.002z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.8050560000000001,
    fill: "#f7c600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.311 344.761l19.141.055s.3-2.485-2-3.994c10.026-1.379 7.422-10.222 15.819-10.723 1.629.25-4.387 3.76-4.387 3.76s-5.062 3.572-2.757 5.388c1.83 1.442 2.632-.877 2.883-2.632.25-1.754 8.146-2.882 7.018-7.895-1.88-4.135-12.908 2.757-12.908 2.757l-7.868-.044c-.49-.883-2.66-4.424-4.898-4.44-2.657.097-4.528 4.484-4.528 4.484H529.03s-.61 4.566 8.413 5.443c2.032 2.653 3.607 3.395 5.373 4.082-1.178.98-1.51 2.168-1.504 3.76z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.80542686,
    fill: "#f7c600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.69 340.873l15.942-.055M535.387 331.47s1.276 7.456 7.163 9.222",
    stroke: "#000",
    strokeWidth: 0.80542686,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.32 170.54c.445-2.151 1.261-2.522 2.151-5.267.149-2.67-2.151-2.374-1.483-4.08 1.187-1.855.593-3.635-1.632-5.045.445 2.448-2.894 4.748-2.894 6.751s1.707 1.558 1.484 4.6c.148 1.78-.445 1.335-.593 3.041h2.967z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.609,
    fill: "url(#m)",
    transform: "matrix(1.3225 0 0 1.3225 446.695 105.83)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.62 313.688a2.256 2.256 0 1 1-4.512.002 2.256 2.256 0 0 1 4.512-.002z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.80542686,
    fill: "#f7c600"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M434.677 297.99l12.347-18.134 12.406 18.172",
    stroke: "#f7c600",
    strokeWidth: 1.71797946,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.504 291.202a2.452 2.452 0 1 1-4.904.002 2.452 2.452 0 0 1 4.904-.002z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.8050560000000001,
    fill: "#f7c600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.998 311.387l19.141.054s.3-2.484-1.999-3.994c10.026-1.379 7.421-10.222 15.818-10.723 1.629.25-4.387 3.76-4.387 3.76s-5.062 3.572-2.757 5.388c1.83 1.442 2.632-.877 2.883-2.631.25-1.755 8.146-2.883 7.018-7.895-1.88-4.136-12.908 2.757-12.908 2.757l-7.868-.044c-.49-.883-2.66-4.424-4.898-4.44-2.657.096-4.528 4.484-4.528 4.484h-17.796s-.61 4.565 8.413 5.443c2.032 2.653 3.607 3.394 5.373 4.08-1.178.982-1.51 2.17-1.504 3.76z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.80542686,
    fill: "#f7c600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.376 307.498l15.943-.054M431.074 298.095s1.276 7.457 7.163 9.223",
    stroke: "#000",
    strokeWidth: 0.80542686,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.32 170.54c.445-2.151 1.261-2.522 2.151-5.267.149-2.67-2.151-2.374-1.483-4.08 1.187-1.855.593-3.635-1.632-5.045.445 2.448-2.894 4.748-2.894 6.751s1.707 1.558 1.484 4.6c.148 1.78-.445 1.335-.593 3.041h2.967z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.609,
    fill: "url(#n)",
    transform: "matrix(1.3225 0 0 1.3225 342.382 72.456)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.307 280.313a2.256 2.256 0 1 1-4.512.002 2.256 2.256 0 0 1 4.512-.002z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.80542686,
    fill: "#f7c600"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M500.741 384.174s4.995 11.516 10.684 4.44 3.608-10.129 3.608-10.129l-12.765-6.937-3.747 7.909 2.22 4.717z",
    fillRule: "evenodd",
    strokeWidth: 0.80542686,
    fill: "#f7c600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.705 382.653s.833.139 1.526-1.11-1.526-1.804-2.497-3.191l-1.11 2.22 2.081 2.081zM482.834 379.598l-11.239 6.105s-5.55 1.11-5.966 0c-.416-1.11.139-2.081 3.052-2.22 2.914-.139 10.823-7.354 10.823-7.354l3.33 3.469zM482.98 179.934s.277 2.636.416 4.023-2.22 4.302-2.359 4.163-1.249.139-1.11.971 1.804 1.11 1.804 1.11-.694 2.914 0 3.053c.694.139-1.804 3.746 0 4.717 1.804.971 4.856 2.22 6.244 1.943 1.387-.278 0 5.411 0 5.411l-3.885 8.325 21.367-2.22-4.44-7.076s-2.082-1.388-1.527-5.412c.555-4.023-.277-22.2-.277-22.2l-15.262-2.081-.972 5.273zM479.091 211.569s-6.937 3.191-6.66 11.794c-1.803 8.325-2.775 16.65-2.775 16.65s-8.186 9.295-10.683 12.626c-2.498 3.33-6.244 10.128-7.632 11.932s-6.799 7.77-6.66 9.99c.139 2.22-1.249 12.072 4.163 13.181 1.387.555 5.827-11.377 5.827-11.377s.278-5.134-1.248-6.105 3.33-4.301 3.33-4.301 9.296-6.8 11.377-8.464 7.77-8.048 7.77-8.048l3.191-37.879z",
    fillRule: "evenodd",
    strokeWidth: 0.80542686,
    fill: "#ffc6b5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487 205.048s1.804 4.856 5.828 4.023c4.023-.832 8.741-4.579 8.741-4.579s3.746-.138 4.301.417c.555.555 10.129 9.85 9.852 12.765-.278 2.914-4.44 2.08-5.967 4.023s-4.024 6.8-3.33 10.407 2.775 8.325 2.498 10.129-1.804 2.358-1.804 3.33c0 .97 1.249 2.636 1.249 4.44s-1.665 4.44-1.388 6.243c.278 1.804.417 7.076.417 7.076l-.417 24.421s1.388.833 1.527 2.22c.138 1.388 9.435 41.763 9.435 41.763s-.417 1.25-1.388 1.11 3.746 6.244 3.885 8.048 4.856 15.957 4.718 17.9c-.14 1.942-.833 6.243-1.25 6.382-.415.139 3.053 8.88 2.498 10.267-.555 1.388-6.243 1.25-6.243 1.25l-1.527-.278s.14 1.803-.97 1.942-9.297-.416-9.297-.416-2.359 3.607-3.746 3.469c-1.388-.14-3.192-2.637-3.608-2.22-.416.416 1.249 2.775.832 3.468-.416.694-7.492 2.22-8.88-1.11-1.387-3.33.833-2.497.417-3.19-.417-.695-3.608-2.498-4.579-1.943s2.497 1.387 2.359 2.775c-.139 1.387-3.053 3.468-4.163 3.468s-3.746-5.133-7.631-4.578c-3.885.555-6.383 1.526-6.383 1.526s-4.578 1.942-6.521 1.526c-1.942-.416-2.775-1.942-2.775-2.775 0-.832 1.388-4.44 1.249-5.55s-1.249-2.22-1.249-3.885c0-1.665 3.191-7.354 3.191-7.354l-.138-25.53s-2.914 0-3.053-1.804 4.44-40.376 5.134-42.874c.694-2.498 2.497-11.378 2.497-11.378s-2.08.972-2.22 0 6.244-23.032 6.244-23.032 1.11-10.961 1.11-13.875c0-2.913-.555-6.937-.555-6.937s-5.696-2.412-5.827-6.105c-.521-5.877 5.41-9.158 6.105-11.1l2.775-7.77s3.052-5.273 8.047-6.105z",
    fillRule: "evenodd",
    strokeWidth: 0.80542686,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.924 381.264s-13.458 7.077-15.401 7.632c-1.943.555-3.192-2.359-1.249-2.914 1.943-.555 4.995-.833 4.995-.833s-4.579-3.607-4.44-3.746c.139-.139 6.244-2.358 6.383-2.358s1.942 3.607 3.19 3.33 4.857-3.053 4.857-3.053 1.943 2.22 1.665 1.942z",
    fillRule: "evenodd",
    strokeWidth: 0.80542686,
    fill: "#f7c600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.889 385.14c1.273 1.64 1.77 4.487 4.684 2.822s-1.493-4.755-1.493-4.755l-3.191 1.932zM509.206 384.862s1.387 1.11 2.636-.139-2.498-3.885-2.498-3.885l-1.803 2.081 1.665 1.943z",
    fillRule: "evenodd",
    strokeWidth: 0.80542686,
    fill: "#ffc6b5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.04 210.458s-12.35 7.909-12.072 10.684M507.817 211.845s-2.775 3.053-2.914 3.053M511.56 215.176s-6.105 4.995-5.134 8.186M482.702 209.765s-1.804 3.746-1.388 4.995c.417 1.249 3.47 5.966 3.885 8.88.417 2.914 0 4.995 0 4.995M479.515 216.702s.554 4.44 1.387 5.272c.833.833 3.053 4.58 3.33 6.105M478.404 235.155s3.607 1.804 6.937-5.134M490.743 225.166c-.139 0-2.636 6.799 1.804 9.296s7.77 2.22 9.712 1.527c1.943-.694 4.024-1.943 4.024-1.943M488.812 233.491s.277 9.158 13.736 18.177M489.367 242.093s-.138 8.048 5.134 11.655M486.59 232.658s-4.024 11.933-7.215 13.182M485.334 241.4s-.139 8.603-1.249 11.655M482.98 255.136s2.775 3.469 5.827 3.191c3.053-.277 4.301-3.885 6.383-3.33 2.08.556 4.023 2.22 8.88 1.804M497.13 260.408s0 7.076 1.25 7.77.693 7.215.693 7.215M480.202 257.079s-.138 6.66-.971 9.019c-.832 2.358-2.497 6.382-2.22 9.851M471.738 279.839c.694-.278 3.053-2.359 3.053-2.359M476.036 279.005s-5.966 25.53-4.301 40.793M477.425 280.249s-3.053 19.147-1.665 22.755M475.904 279.693c.139 0 11.655.833 11.655.833M489.222 279.005s3.191 1.666 7.631 1.388M487.833 288.303s-.555 32.745-1.387 39.96M504.907 295.788s3.608 28.722 5.69 31.358M497.964 299.399s2.22 25.392 3.469 27.612M466.474 335.888s4.301-1.388 8.186-5.55c4.44 5.966 11.24.278 11.24.278s10.544 7.215 15.261-.833c7.215 4.718 10.823-.694 10.823-.694s2.636 4.024 4.579 3.608M505.04 335.478s5.41 25.391 13.458 32.606M477.147 332.833s.694 21.23 1.943 36.214M476.182 356.837s-.694 13.875-1.527 14.847M467.995 373.078s1.526 5.966 9.158.416c7.631-5.55 7.77 2.082 8.047 2.914.278.832 1.527 6.799 4.44 1.804M495.742 370.023s-1.249 12.348 9.713 3.33c10.961-9.019 12.765-.139 13.042 2.636",
    strokeWidth: 0.80542686,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.556 179.1s3.053.417 4.718-.554c1.665-.972 3.608-1.388 4.995.555s2.359 1.803 2.359 1.803-2.082 5.134 0 5.689c2.081.555 3.052.555 3.191 1.249.139.694-1.804 2.22-1.249 2.913.555.694 1.527 1.527 1.665 2.082.139.555-1.248 2.913-.832 3.469.416.555 1.665 2.775 2.497 2.775.833 0 .278 3.468 2.775 2.636s2.36-3.053 2.36-3.053 2.635-.416 3.33-2.775c.693-2.358 2.358-2.913 2.358-2.913s3.33-1.804-1.11-4.58c0-19.425-12.765-17.343-12.765-17.343s-1.527-3.469-4.024-3.053c-2.498.417-2.636 3.33-4.44 3.053-1.804-.278-2.22-1.526-2.359-1.387-.139.138-1.665 2.913-1.665 3.607 0 .694-4.856-.971-4.44 2.636s2.775 3.469 2.636 3.192z",
    fillRule: "evenodd",
    strokeWidth: 0.80542686,
    fill: "#9c5100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.888 174.383s-.972 6.105 5.55 5.55c-.833 3.33 1.665 4.44 1.665 4.44M507.95 188.119c.138 0 2.913 1.804-.14 4.024M498.52 192.975s1.387 1.665 2.913 1.25c1.526-.417 4.024 1.525 4.024 1.525s2.081.694 2.359.278M490.055 198.248s4.718 1.804 7.77-5.688M481.313 190.34l2.775.138",
    strokeWidth: 0.80542686,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M481.736 193.114h2.498l-2.22.972",
    strokeWidth: 0.80542686,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M485.201 185.344c.417 0 1.943-.555 2.22-.138.278.416-1.665.693-2.22.138z",
    strokeWidth: 1.4495038400000002,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.17 218.31c.139 0 4.58 13.736 5.134 17.205.555 3.469 2.359 17.344 1.665 19.287-.694 1.942-7.77 11.238-8.603 13.597-.832 2.358-5.827 11.377-5.827 11.377s-1.249 8.88-1.804 9.297c-.555.416 1.433 2.596 1.249 3.33-.275.826-4.024 4.717-5.689 4.301-1.665-.416-4.301-2.359-4.44-4.163s.139-7.77 1.388-9.296 7.77-16.927 8.186-17.9c.416-.97 5.966-13.042 6.105-15.122.139-2.082-1.727-6.894-3.689-8.66-4.367-12.853-2.65-20.604 6.325-23.253z",
    fillRule: "evenodd",
    strokeWidth: 0.80542686,
    fill: "#ffc6b5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.524 277.842l.218 6.08M444.827 277.392s3.898 6.52 3.573 9.994",
    strokeWidth: 0.80542686,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M497.078 291.014s2.915-.306 2.823 4.56c1.861-6.045 5.646-6.189 5.646-6.189",
    strokeWidth: 0.80542686,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M487.119 429.949c58.598-1.628 96.443-43.949 96.036-44.356-.407-.407 7.732-11.8 14.243-10.173 6.51 1.627 15.87 20.753 27.264 24.822 5.697 8.953-1.627 17.092-4.069 18.72-2.442 1.627-13.429 6.104-15.057-.407-1.627-6.511-4.883-5.29-4.883-5.29s-52.088 50.867-112.31 48.832c-62.257.41-113.53-48.83-113.53-48.83l-4.477 4.883s-4.883 5.29-7.324 4.883c-2.442-.407-13.023-7.325-13.837-14.243-.813-6.918 6.511-11.394 6.511-11.394s17.906-13.836 19.94-21.16c4.07-4.07 11.8 2.848 11.8 2.848s47.205 54.123 99.7 50.868z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.7173345,
    fill: "#f7c600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.464 398.476s4.842-1.29 6.618.727c1.775 2.017 13.961 13.961 13.961 13.961",
    stroke: "#000",
    strokeWidth: 1.7173345,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.52 404.122l-4.843 3.632s12.186 2.42 9.442 10.41M620.297 398.066s-2.421-1.291-6.214 1.533c-3.793 2.825-13.397 13.558-13.397 13.558",
    stroke: "#000",
    strokeWidth: 1.7173345,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.406 403.804l5.245 4.035s-10.975.726-8.554 11.137",
    stroke: "#000",
    strokeWidth: 1.7173345,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.495 411.39l-.352.495c-.736-.364-1.576-.431-2.519-.203-.692.179-1.996.83-3.912 1.95l-16.125 9.4-.44-.314 4.061-18.85c.491-2.272.715-3.652.673-4.14-.033-.48-.374-1.013-1.02-1.595l.352-.495 8.692 6.199-.353.495-.294-.21c-.785-.56-1.39-.843-1.815-.85-.3-.013-.542.11-.727.369-.114.16-.215.377-.303.65-.081.266-.257 1.021-.527 2.268l-2.572 11.782 9.315-5.481c1.12-.667 1.847-1.13 2.18-1.39.334-.26.583-.505.749-.737.19-.268.287-.555.291-.862.003-.306-.095-.612-.295-.916-.275-.425-.729-.863-1.362-1.314l.353-.495 5.95 4.244m5.79 28.018l-.29.533-10.218-5.587.292-.533.648.354c.567.31 1.079.459 1.535.446.323.002.641-.123.955-.376.231-.173.615-.75 1.151-1.73l7.03-12.853c.546-.999.834-1.652.865-1.96.031-.307-.067-.642-.293-1.003-.212-.365-.592-.698-1.14-.997l-.648-.355.291-.533 10.217 5.587-.292.533-.648-.354c-.567-.31-1.078-.46-1.534-.446-.324-.003-.647.12-.97.368-.231.173-.615.75-1.15 1.729l-7.03 12.854c-.547.999-.835 1.652-.866 1.96-.022.313.074.652.286 1.017.226.362.614.692 1.161.991l.649.355m37.323-8.754l-2.634 7.395-.572-.204c.029-2.267-.46-4.174-1.468-5.718-1.008-1.544-2.331-2.609-3.971-3.193-1.568-.558-3.03-.58-4.388-.063-1.355.505-2.53 1.47-3.525 2.894a19.392 19.392 0 0 0-2.38 4.627c-.716 2.01-1.107 3.86-1.173 5.544s.301 3.072 1.1 4.158c.809 1.09 1.94 1.894 3.395 2.412.505.18 1.04.312 1.602.397.577.077 1.18.112 1.81.104l1.555-4.363c.294-.825.426-1.377.397-1.654-.025-.288-.183-.594-.475-.919-.28-.32-.674-.571-1.179-.751l-.542-.193.204-.573 10.196 3.632-.204.572c-.792-.224-1.372-.308-1.74-.253-.354.048-.68.228-.977.54-.163.164-.38.627-.652 1.39l-1.554 4.363c-1.554.12-3.111.071-4.672-.147a22.752 22.752 0 0 1-4.668-1.14c-1.99-.709-3.55-1.567-4.68-2.573a13.566 13.566 0 0 1-2.72-3.375c-.685-1.244-1.114-2.518-1.289-3.824-.215-1.68-.008-3.403.62-5.167 1.125-3.156 3.183-5.427 6.176-6.814 2.993-1.386 6.17-1.48 9.533-.283 1.042.371 1.95.788 2.728 1.25.424.245 1.072.743 1.943 1.495.885.745 1.42 1.15 1.606 1.217.29.103.594.095.915-.023.325-.128.695-.45 1.11-.964l.573.204m15.724 25.238l-.09.601-11.514-1.744.09-.6.732.11c.638.097 1.17.06 1.594-.107.304-.11.56-.336.768-.682.158-.241.32-.914.488-2.019l2.194-14.485c.171-1.125.218-1.838.142-2.138-.077-.3-.284-.58-.62-.841-.325-.27-.796-.453-1.413-.546l-.73-.11.09-.602 11.514 1.744-.091.601-.731-.11c-.639-.097-1.17-.062-1.594.107-.305.109-.566.335-.784.678-.159.242-.322.915-.489 2.02l-2.194 14.484c-.17 1.126-.218 1.839-.141 2.138.087.302.293.587.617.858.337.262.814.439 1.431.532l.731.111m29.886-7.26l-.439 7.851-19.748 1.008-.031-.607.738-.038c.645-.033 1.158-.174 1.54-.424.277-.167.482-.441.616-.82.107-.27.132-.961.075-2.077l-.746-14.63c-.058-1.138-.155-1.845-.29-2.123-.134-.279-.393-.512-.775-.7-.372-.201-.87-.285-1.493-.254l-.738.038-.031-.607 11.859-.605.03.607-.967.05c-.645.032-1.159.174-1.54.423-.277.168-.488.442-.633.822-.107.269-.132.96-.075 2.076l.723 14.172c.058 1.137.16 1.86.308 2.171.147.3.416.516.806.65.279.084.943.1 1.993.046l1.853-.094c1.181-.06 2.155-.319 2.92-.774.767-.456 1.411-1.147 1.934-2.072.534-.927 1.013-2.278 1.438-4.054l.673-.034m21.602-3.748l-7.538 2.252-.276 2.345c-.087.78-.063 1.396.072 1.847.178.598.551.967 1.118 1.106.334.083 1.07 0 2.206-.248l.174.583-7.097 2.12-.174-.582c.731-.345 1.267-.847 1.606-1.509.337-.672.624-1.929.862-3.771l2.546-19.308.299-.089 12.922 15.2c1.23 1.439 2.145 2.302 2.746 2.592.453.218 1.013.257 1.68.115l.174.582-10.324 3.084-.174-.582.425-.127c.829-.248 1.377-.537 1.643-.868.181-.237.224-.513.13-.828a2.014 2.014 0 0 0-.268-.554c-.05-.088-.324-.434-.825-1.039l-1.927-2.32m-.883-1.006l-5.375-6.399-1.077 8.327 6.452-1.927m28.46-29.002l2.855 5.309-.521.28c-.967-1.06-1.781-1.753-2.443-2.08-.666-.339-1.413-.49-2.24-.456-.46.023-1.147.281-2.064.774l-1.46.785 8.135 15.132c.539 1.003.929 1.601 1.17 1.795.25.189.587.294 1.009.316.426.007.919-.14 1.478-.441l.651-.35.288.535L550.985 442l-.288-.535.651-.35c.569-.306.973-.654 1.21-1.043.18-.27.252-.607.22-1.013-.018-.289-.291-.925-.82-1.908l-8.135-15.132-1.418.762c-1.321.71-2.13 1.506-2.428 2.387-.419 1.232-.35 2.631.206 4.197l-.55.296-2.854-5.31 17.619-9.472m13.359-7.92l5.46 7.237.353-.267c1.128-.85 1.678-1.82 1.651-2.911s-.492-2.38-1.394-3.866l.499-.376 7.022 9.31-.498.375c-.87-.934-1.72-1.597-2.548-1.986-.82-.397-1.536-.536-2.146-.418-.618.109-1.35.483-2.198 1.123l3.778 5.008c.739.98 1.23 1.549 1.473 1.708.252.152.545.213.878.181.333-.031.752-.238 1.26-.62l1.061-.802c1.661-1.253 2.7-2.64 3.116-4.16.425-1.528.263-3.243-.487-5.146l.485-.366 3.463 6.254-15.368 11.591-.366-.485.59-.445c.516-.389.862-.794 1.038-1.215.135-.294.152-.635.05-1.025-.062-.282-.43-.87-1.102-1.76l-8.822-11.697c-.607-.804-1.001-1.281-1.183-1.432a1.572 1.572 0 0 0-1.02-.342c-.516.006-1.063.226-1.64.662l-.59.445-.366-.485 14.882-11.226 3.966 5.258-.498.376c-1.223-1.094-2.277-1.746-3.162-1.956-.877-.217-1.834-.14-2.87.231-.609.212-1.586.826-2.932 1.841l-1.836 1.385"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.537 413.063c72.788 59.04 144.131 60.122 213.933 0",
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVg);
export default __webpack_public_path__ + "static/media/vg.87baf5cf3ea00eddea9ff2b7a1aa6cc5.svg";
export { ForwardRef as ReactComponent };